import React from 'react';

import { I18n } from '@aws-amplify/core';

import { ResultBadge } from '@/components/views/Report/KimLhc/Components/Shared/Badges';
import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';
import { getFormatNumberByLocale } from '@/utils/get-format-number-locale';

interface ScoreBadgeProps {
	score: number;
	maxScore: number;
	label: string;
}

export function ScoreBadge({ score, maxScore, label }: Readonly<ScoreBadgeProps>) {
	return (
		<>
			<S.ScoreLabel>{I18n.get(label)}</S.ScoreLabel>
			<ResultBadge>
				<span>
					<strong>{getFormatNumberByLocale(score)}</strong>/{maxScore}
				</span>
			</ResultBadge>
		</>
	);
}
